"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhoneLengthError = exports.isPhoneLengthValid = exports.enforcePhoneNumberLength = exports.getRequiredPhoneDigits = exports.stripNonDigits = void 0;
var libphonenumber_js_1 = require("libphonenumber-js");
var examples_mobile_json_1 = __importDefault(require("libphonenumber-js/examples.mobile.json"));
var MOBILE_EXAMPLES = examples_mobile_json_1.default;
var stripNonDigits = function (value) {
    if (value === void 0) { value = ""; }
    return value.replace(/\D/g, "");
};
exports.stripNonDigits = stripNonDigits;
var getRequiredPhoneDigits = function (countryCode) {
    var _a;
    if (!countryCode)
        return undefined;
    var normalizedCountry = countryCode.toUpperCase();
    var example = MOBILE_EXAMPLES[normalizedCountry];
    if (!example)
        return undefined;
    var digits = (0, exports.stripNonDigits)(example);
    var exampleLength = digits.length > 0 ? digits.length : undefined;
    var overrides = {
        NA: 9, // Namibia numbers are 9 digits (excluding leading 0 trunk prefix)
    };
    var overrideLength = (_a = overrides[normalizedCountry]) !== null && _a !== void 0 ? _a : undefined;
    return overrideLength !== null && overrideLength !== void 0 ? overrideLength : exampleLength;
};
exports.getRequiredPhoneDigits = getRequiredPhoneDigits;
var enforcePhoneNumberLength = function (value, countryCode) {
    var normalizedCountry = countryCode === null || countryCode === void 0 ? void 0 : countryCode.toUpperCase();
    var digitsOnly = (0, exports.stripNonDigits)(value);
    var requiredLength = (0, exports.getRequiredPhoneDigits)(normalizedCountry);
    var nationalDigits = digitsOnly;
    if (normalizedCountry) {
        try {
            var callingCode = (0, libphonenumber_js_1.getCountryCallingCode)(normalizedCountry);
            if (callingCode && nationalDigits.startsWith(callingCode)) {
                nationalDigits = nationalDigits.slice(callingCode.length);
            }
        }
        catch (_a) {
            // ignore missing country calling code
        }
    }
    var allowsTrunkPrefix = normalizedCountry === "NA" &&
        requiredLength !== undefined &&
        nationalDigits.startsWith("0") &&
        nationalDigits.length === requiredLength + 1;
    var trimmedNational = requiredLength !== undefined && !allowsTrunkPrefix
        ? nationalDigits.slice(0, requiredLength)
        : nationalDigits;
    if (!normalizedCountry) {
        return trimmedNational;
    }
    try {
        return (0, libphonenumber_js_1.formatIncompletePhoneNumber)(trimmedNational, normalizedCountry);
    }
    catch (error) {
        console.warn("Unable to format phone number for country \"".concat(normalizedCountry, "\":"), error);
        return trimmedNational;
    }
};
exports.enforcePhoneNumberLength = enforcePhoneNumberLength;
var isPhoneLengthValid = function (value, countryCode) {
    var requiredLength = (0, exports.getRequiredPhoneDigits)(countryCode);
    if (!requiredLength)
        return true;
    var digits = (0, exports.stripNonDigits)(value);
    if (digits.length === requiredLength)
        return true;
    if (typeof countryCode === "string" &&
        countryCode.toUpperCase() === "NA" &&
        digits.startsWith("0") &&
        digits.length === requiredLength + 1) {
        return true;
    }
    return false;
};
exports.isPhoneLengthValid = isPhoneLengthValid;
var getPhoneLengthError = function (phone, label) {
    var _a;
    if (!((_a = phone === null || phone === void 0 ? void 0 : phone.phone_number) === null || _a === void 0 ? void 0 : _a.trim()))
        return undefined;
    if ((0, exports.isPhoneLengthValid)(phone.phone_number, phone.country_abbreviation)) {
        return undefined;
    }
    var expectedLength = (0, exports.getRequiredPhoneDigits)(phone.country_abbreviation);
    if (expectedLength) {
        if (typeof phone.country_abbreviation === "string" &&
            phone.country_abbreviation.toUpperCase() === "NA") {
            return "".concat(label, " must be ").concat(expectedLength, " digits (or ").concat(expectedLength + 1, " including the leading 0) for the selected country");
        }
        return "".concat(label, " must be ").concat(expectedLength, " digits for the selected country");
    }
    return "".concat(label, " is invalid for the selected country");
};
exports.getPhoneLengthError = getPhoneLengthError;
